module.exports = __webpack_public_path__ + "img/08.47f17cf1.gif";